import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container } from './nav.css';
import LogoHorz from './logo-horz';
import LogoSmall from './logo-small';
import LogoText from './logo-text';
import ProgressIndicator from '../progress-indicator';

const Nav = ({ queryParams, steps, progress }) => {
  if (queryParams && queryParams.small && queryParams.small === 'true') {
    return (
      <Fragment>
        <Container small>
          <LogoSmall />
          <LogoText />
        </Container>
        <ProgressIndicator steps={steps} progress={progress} />
      </Fragment>
    );
  }
  return (
    <Container>
      <LogoHorz />

      <a href="https://www.sold.com/why-sold">Why Sold?</a>
    </Container>
  );
};

Nav.propTypes = {
  queryParams: PropTypes.object,
  steps: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
};

export default Nav;
